import Vue from 'vue'
import App from './App.vue'
//import router from './router'
//import Parser from "./components/Parser";
import store from './store'
import VueNativeSock from 'vue-native-websocket'
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'


Vue.config.productionTip = false;

Vue.filter('twoDecimals', function(value){
    return parseFloat(value).toFixed(2);
});

new Vue({
    el: '#app',
    //router: router,
    store: store,
    //render: h => h(App)
    //render: h => h(Parser)
    render: function(createElement) {
        return createElement(App);
    }
});

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);

Vue.use(VueReCaptcha, {
    siteKey: '6LfuOdMZAAAAAJgnSWSF_xnfwxF1DuHCyYP7ChlK'
});

Vue.use(VueNativeSock, 'wss://varuosaparser.ee/ws', {
    store: store,
    format: 'json',
    reconnection: true, // (Boolean) whether to reconnect automatically (false)
    reconnectionAttempts: 50, // (Number) number of reconnection attempts before giving up (Infinity),
    reconnectionDelay: 5000, // (Number) how long to initially wait before attempting a new (1000)
});
